const linksYTData = [
  {
    link: 'https://www.youtube.com/channel/UCY10FZglXJ8RL3xB04VpykQ',
    name: 'Code-dojo',
  },
  {
    link: 'https://www.youtube.com/channel/UCVTlvUkGslCV_h-nSAId8Sw',
    name: 'Learn-code',
  },
  {
    link: 'https://www.youtube.com/channel/UC8butISFwT-Wl7EV0hUK0BQ',
    name: 'FreeCodeCamp',
  },
  {
    link: 'https://www.youtube.com/channel/UCKPbiit_j8ycmkutM0wVzdA',
    name: 'Ilya Kantor',
  },
  {
    link: 'https://www.youtube.com/channel/UCyUFMVZ6VnbB5a8d_EyrFBQ',
    name: 'Monster Lessons',
  },
  {
    link: 'https://www.youtube.com/channel/UCzgtMBarT8AvsGc-Y_8Qexw',
    name: 'Точка dev',
  },
  {
    link: 'https://www.youtube.com/channel/UChUxTMjJGo-JDRY8pNTGL2g',
    name: 'Html academy',
  },
  {
    link: 'https://www.youtube.com/channel/UCJbPGzawDH1njbqV-D5HqKw',
    name: 'Thenewboston',
  },
  {
    link: 'https://www.youtube.com/channel/UCZeU17nbVfzczAkJVTay9vw',
    name: 'UWebDesign',
  },
  {
    link: 'https://www.youtube.com/channel/UCSJbGtTlrDami-tDGPUV9-w',
    name: 'Academind',
  },
  {
    link: 'https://www.youtube.com/channel/UCIIt69f5D44s2cdb9vXQNzA',
    name: 'LoftBlog',
  },
  {
    link: 'https://www.youtube.com/channel/UCdnFX7mzgup9moXG2fULOog',
    name: 'Sorax',
  },
  {
    link: 'https://www.youtube.com/channel/UCW5YeuERMmlnqo4oq8vwUpg',
    name: 'The Net Ninja',
  },
  {
    link: 'https://www.youtube.com/channel/UC7enHM_oJRYJOnyJrcRzwbg',
    name: 'WebDesign Master',
  },
  {
    link: 'https://www.youtube.com/channel/UCSsg9NLCse2XQCIRgfmJu3Q',
    name: 'Aida Drogan ',
  },
  {
    link: 'https://www.youtube.com/channel/UCzxRv9BtqrM946JmaMLtv_w',
    name: 'ITVDN',
  },
  {
    link: 'https://www.youtube.com/channel/UC22agoQFT4q0dsbrQbUlgjA',
    name: 'Dmitry Valak',
  },
  {
    link: 'https://www.youtube.com/channel/UCGuhp4lpQvK94ZC5kuOZbjA',
    name: 'Web4myself',
  },
  {
    link: 'https://www.youtube.com/channel/UC07wMMCxl78fsvYlWVZ1wWw',
    name: 'JsWiz',
  },
  {
    link: 'https://www.youtube.com/channel/UCaF5gPbgsJ6ljx6-rBCOmhA/feed',
    name: 'Programming Computer',
  }
];

export default linksYTData;



// WEBPACK FOOTER //
// ./src/assets/linksYTData.js